module.exports = __webpack_public_path__ + "img/browse-vehicles-background-chevy.e92c68c4.png";